import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { IconComponent } from '@fc-shared/ui/icon/icon.component';
import {
  QuickSearchTypeTab,
  QuickSearchType,
} from '@fc-search/models/quick-search';
import { FcTab, FcTabGroup, FcTabLabel } from '@fc-shared/ui/tabs';

@Component({
  selector: 'fc-quick-search-tabs',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, FcTabGroup, FcTab, FcTabLabel],
  template: `
    <div class="px-12 pt-4">
      <fc-tab-group
        [selectedIndex]="selectedIndex()"
        (selectedIndexChange)="onTabChange($event)"
        (keydown)="$event.stopPropagation()"
      >
        @for (tab of tabs(); track tab.id; let i = $index) {
          <fc-tab>
            <ng-template fc-tab-label>
              @if (tab.icon) {
                <fc-icon
                  [icon]="tab.icon"
                  [size]="24"
                  [color]="
                    i === selectedIndex() ? 'primary600' : 'secondary400'
                  "
                />
              } @else {
                <span class="text-sm font-medium">{{ tab.label }}</span>
              }
            </ng-template>
          </fc-tab>
        }
      </fc-tab-group>
    </div>
  `,
  styles: `
    :host ::ng-deep .fc-tab-label {
      min-width: 56px;
      padding: 0 12px;
      height: 40px;
    }
  `,
})
export class QuickSearchTabsComponent {
  tabs = input.required<QuickSearchTypeTab[]>();
  selectedType = input.required<QuickSearchType>();
  tabSelected = output<QuickSearchType>();

  selectedIndex = computed(() =>
    this.tabs().findIndex((t) => t.id === this.selectedType()),
  );

  onTabChange(index: number): void {
    const type = this.tabs()[index]?.id;
    if (type && type !== this.selectedType()) {
      this.tabSelected.emit(type);
    }
    // remove focus from the tab to prevent triggering hotkeys when using arrows to navigate search results
    (document.activeElement as HTMLElement)?.blur();
  }
}
